var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.006 17.822 5.68 20.215M14.965 17.822l1.326 2.393M10.984 18.886a7.958 7.958 0 1 0 0-15.917 7.958 7.958 0 0 0 0 15.917"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.294 8.808a3.98 3.98 0 1 1 5.58-5.557M10.986 2.97V1.646M10.986 6.951v3.98M10.986 10.93l2.814 2.813M18.677 8.808a3.979 3.979 0 1 0-5.581-5.557"
  })));
};
export { SvgClock as ReactComponent };
export default __webpack_public_path__ + "images/clock.svg";